import { createContext, useContext, ParentComponent } from "solid-js";
import { DenominationGridState } from "~/hooks/denominations_grid/useDenominationsGrid";

const DenominationsGridV2Context = createContext<DenominationGridState>();

export const DenominationsGridWebstoreTelescopeProvider: ParentComponent<{
  value: DenominationGridState;
}> = (props) => {
  return (
    <DenominationsGridV2Context.Provider value={props.value}>
      {props.children}
    </DenominationsGridV2Context.Provider>
  );
};

export const useDenominationsGridWebstoreTelescopeContext = () => {
  const context = useContext(DenominationsGridV2Context);
  if (!context) {
    throw new Error(
      "useDenominationsGridV2Context must be used within a DenominationsGridV2Provider"
    );
  }
  return context;
};
